<template>
  <div>
    {{ ActDescBtn }}
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Cambiar precios de productos rapidamente'"
          :show-absolute="false"
          :titulo="'Cambio de Precio'"
          @MethodEliminar="remove"
          @MethodGuardar="guardar"
          @MethodNuevo="newnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Barra de busqueda --->
        <v-col v-show="BarraPrimariaAbrir" :max-height="this.windowSize.height - 96" cols="3">
          <div
            class="overflow-y-auto"
            v-bind:style="{
              'max-height': this.windowSize.height - 96 + 'px',
            }"
          >
            <v-tooltip left>
              <template v-slot:activator="{ on }">
                <!-- <v-navigation-drawer >  -->

                <BarraDinamicaLimitePlus
                  :ContListSlot="[
                    { Text: 'Codigo', NomValue: 'codigo', Ctsl: 1, Type: 0, State: true },
                    { Text: 'Nombre', NomValue: 'nombre', Ctsl: 1, Type: 0, State: true },
                    { Text: 'rnc', NomValue: 'rnc', Ctsl: 1, Type: 0, State: true },
                  ]"
                  :PropsList="proveedorList"
                  :PropsNombre="'Proveedores'"
                  :PropsSeachNombre="'Búsqueda por nombre o codigo'"
                  :TbPaginator="TbPaginator"
                  :TbTotalItem="totalItems"
                  :headers="[{ text: 'Código', value: 'secuencia' }]"
                  props-search
                  @CargarPaginacion="CargarPaginacion"
                  @EmitDAta="datostabla"
                />
              </template>
            </v-tooltip>
          </div>
        </v-col>
        <!-- fn Barra de busqueda --->

        <!-- Contenido central --->
        <v-col :max-height="this.windowSize.height - 96">
          <v-app
            id="inspire"
            class="overflow-y-auto"
            v-bind:style="{ 'max-height': this.windowSize.height - 96 + 'px' }"
          >
            <div class="px-2">
              <!---- Formulario ----->
              <v-form ref="form" v-model="valid" lazy-validation>
                <v-card color="grey lighten-3">
                  <div class="px-2">
                    <v-row>
                      <!-- columna 1 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-row dense>
                          <v-text-field v-model="proveedor.codigo" dense label="Codigo" outlined readonly type="number">
                            <template v-slot:prepend>
                              <i class="fa fa-list-ol" style="font-size: 20px; width: 20px"></i>
                            </template>
                          </v-text-field>

                          <v-text-field v-model="proveedor.rnc" class="ml-2" dense label="RNC" outlined readonly>
                            <template v-slot:prepend>
                              <i class="fa fa-id-card-o" style="font-size: 20px; width: 20px"></i>
                            </template>
                          </v-text-field>
                        </v-row>
                      </v-col>
                      <!-- fn columna 1 -->

                      <!-- columna 2 -->
                      <v-col cols="12" md="6" sm="6">
                        <v-text-field v-model="proveedor.nombre" dense label="Nombre" outlined readonly>
                          <template v-slot:prepend>
                            <i class="fa fa-user-circle" style="font-size: 20px; width: 20px"></i>
                          </template>
                        </v-text-field>
                      </v-col>
                      <!-- fn columna 2 -->
                      <v-col cols="12">
                        <v-data-table
                          :key="proveedor.codigo"
                          :footer-props="{
                            itemsPerPageOptions: [10, 20, 30],
                          }"
                          :headers="productoHeaders"
                          :items="productoList"
                          no-data-text="Ningun producto seleccionado"
                        >
                          <template #top>
                            <v-row class="pa-3">
                              <v-col class="d-flex" cols="12" lg="8">
                                <v-autocomplete
                                  ref="unidadProductoComplete"
                                  :disabled="proveedor.codigo === 0"
                                  :item-text="formatUnidadProducto"
                                  :items="unidadProductoList"
                                  :search-input.sync="searchUnidadProducto"
                                  class="mr-2"
                                  clearable
                                  dense
                                  label="Buscar producto"
                                  no-filter
                                  return-object
                                  style="max-width: 30rem"
                                  @change="addProducto"
                                ></v-autocomplete>

                                <v-btn
                                  :disabled="proveedor.codigo === 0"
                                  color="green"
                                  style="color: white"
                                  @click="showDialogAddProducto = true"
                                >
                                  <i class="fa fa-plus-square" style="width: 20px; font-size: 20px"></i>
                                  Agregar producto
                                </v-btn>

                                <v-btn
                                  :disabled="proveedor.codigo === 0"
                                  class="ml-2"
                                  color="blue"
                                  style="color: white"
                                  @click="findAllProductos"
                                >
                                  <i class="fa fa-plus-square" style="width: 20px; font-size: 20px"></i>
                                  Agregar todos
                                </v-btn>
                              </v-col>

                              <v-col class="d-flex" cols="12" lg="4">
                                <VueAutonumeric
                                  v-model.number="aumento"
                                  :disabled="proveedor.codigo === 0 || isAumentoDisabled"
                                  autocomplete="off"
                                  class="mx-2"
                                  dense
                                  label="%Aumento"
                                  style="font-size: 14px; max-width: 7rem"
                                ></VueAutonumeric>

                                <v-btn
                                  :disabled="proveedor.codigo === 0 || productoList.length > 0"
                                  color="blue"
                                  style="color: white"
                                  @click="aumentoGlobal"
                                >
                                  <i class="fa fa-globe" style="width: 20px; font-size: 20px"></i>
                                  Aumento Global
                                </v-btn>
                              </v-col>
                            </v-row>
                          </template>

                          <template v-slot:item.precio="{ item }">
                            <VueAutonumeric
                              v-model="item.precio"
                              dense
                              hide-details
                              style="font-size: 14px; max-width: 4rem"
                              @change="disableAumento"
                            ></VueAutonumeric>
                          </template>

                          <template v-slot:item.costo="{ item }">
                            <VueAutonumeric
                              v-model="item.costo"
                              dense
                              hide-details
                              style="font-size: 14px; max-width: 4rem"
                              @change="disableAumento"
                            ></VueAutonumeric>
                          </template>

                          <template v-slot:item.remover="{ item }">
                            <v-btn color="red" rounded small @click="removeProducto(item)">
                              <i class="fa fa-trash" style="font-size: 20px; color: white"></i>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </div>
                </v-card>
              </v-form>
              <!---- fn Formulario ----->
            </div>
          </v-app>
        </v-col>
        <!-- fn Contenido central ------------------------------------------------------------------------------------->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!-- ------------------------------------------------------ notif-->
    <v-dialog v-model="notif.estado" label="myAlert" max-width="350" persistent transition="fab-transition">
      <template v-slot:activator="{ on }" justify="center"></template>

      <v-card>
        <v-card-title>
          <h4>
            <i class="fa fa-warning" style="font-size: 28px"></i>
            CONFIRMACION
            <i class="fa fa-warning" style="font-size: 28px"></i>
          </h4>
        </v-card-title>
        <hr />

        <v-card-text>
          <h5>{{ notif.nombre }}</h5>
        </v-card-text>

        <hr />
        <v-card-actions>
          <v-btn v-if="notif.Exec == 'AnularCaja'" small @click.prevent="eliminar(), (notif.estado = !notif.estado)">
            <i class="fa fa-check" style="font-size: 20px"></i>
            Si
          </v-btn>

          <v-btn small @click.prevent="notif.estado = !notif.estado">
            <i class="fa fa-ban" style="font-size: 20px"></i>
            No
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- ------------------------------------------------------  fn notif -->

    <!-- ------------------------------------------------------   alerta -->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>
    <!-- ------------------------------------------------------  fn alerta -->

    <!--- Dialogo de buscar producto --->
    <v-dialog
      v-model="showDialogAddProducto"
      label="Modal agregar producto"
      max-height="80%"
      max-width="90%"
      persistent
      transition="fab-transition"
    >
      <AgregarProducto
        ref="addProducto"
        :proveedor="proveedor.codigo"
        :search-by-proveedor="true"
        :statusFoms="showDialogAddProducto"
        :unidad-compra="true"
        @EmitAgregarProducto="addProductoDialog"
      />
    </v-dialog>
    <!--- fn Dialogo de buscar producto --->

    <!--- Dialogo de confirmacion --->
    <DialogoConfirmacion ref="confirmDialog" />
    <!-- ------------------------------------------------------ fn Modal-Reportes-ModalReporteFiltros -->

    <div v-if="ejecucion" class="form-loading-indicator">
      <v-progress-circular color="primary" indeterminate></v-progress-circular>
    </div>
    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import BarraDinamicaLimitePlus from "../../components/BarraDinamicaLimitePlus"
  import BarraBusqueda2 from "../../components/BarraBusquedaDinamLimite"
  import BarraDinamicaLimite from "../../components/BarraDinamicaLimite"
  import { EventBus } from "../../event-bus.js"
  import ContenidoBase from "../../components/ContenidoBase"
  import ModalReporteBasico from "../../components/ModalReporteBasico"
  import ModalReporteFiltros from "../../components/ModalReporteFiltros"
  import { currencyFormatter, fechaNueva, FormatoFecha, getParamFecha, HoraFormatter } from "@/js/Funciones.js"
  import DialogoConfirmacion from "@/components/DialogoConfirmacion.vue"
  import TablaProductoCxP from "@/CuentaXPagar/UtilidadComponents/TablaProductoCxP.vue"
  import VueAutonumeric from "@/components/AutoNumericNuevo.vue"
  import CreacionProductoMovil from "@/Inventario/Mant/CreacionProductoMovil.vue"
  import AgregarProducto from "@/CuentaXPagar/UtilidadComponents/AgregarProducto"

  export default {
    components: {
      CreacionProductoMovil,
      TablaProductoCxP,
      DialogoConfirmacion,
      BarraDinamicaLimite,
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      VueAutonumeric,
      ContenidoBase,
      ModalReporteBasico,
      ModalReporteFiltros,
      AgregarProducto,
    },

    mounted() {
      EventBus.$on("abrirMenuizquierdo", this.abrirTabla)
      //EventBus.$on("abrirMenuizquierdo", this.abrirTabla2);
      EventBus.$on("emitAnular", this.datostabla)
      EventBus.$on("AnularNew", this.new)
      // EventBus.$on("AnularSave", this.save);
      EventBus.$on("AnularRemove", this.remove)
      EventBus.$on("AnularAnular", this.save)
    },

    data() {
      return {
        windowSize: { width: "auto", height: "auto" },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: false,
          eliminar: false,
          anular: false,
          imprimir: false,
          vercuenta: false,
          guardartemporal: false,
          restaurartemporal: false,
          importarDato: false,
          cargarProducto: false,
          ImprimirproductoInv: false,
        },

        valid: true,

        anular: {
          documento: null,
          factura: 0,
          ncf: null,
          tipoAnulacion: null,
        },

        Modallfiltro: {
          factura: null,
          cliente: null,
          Desde: null,
          Hasta: null,
        },

        beneficiarioList: [],

        filtros: {
          secuencia: null,
          beneficiario: "",
          fechaInicial: null,
          fechaFinal: null,
        },

        // Formulario
        proveedorNuevo: {
          codigo: 0,
          nombre: "",
          rnc: "",
        },

        proveedor: {
          codigo: 0,
          nombre: "",
          rnc: "",
        },

        aumento: 0,

        // Listados
        productoHeaders: [
          { text: "Código", value: "productos.codigo", sortable: false },
          { text: "Descripción", value: "productos.descripcion", sortable: false },
          { text: "Precio", value: "precio", sortable: false },
          { text: "Costo", value: "costo", sortable: false },
          { text: "Remover", value: "remover", sortable: false },
        ],
        unidadProductoList: [],
        searchUnidadProducto: "",

        productoList: [],
        proveedorList: [],
        totalItems: 0,

        modificacionesManuales: 0,

        showDialogAddProducto: false,

        ObjTemTbDinam: null,
        List: [],
        TbTotalItem: 0,
        TbPaginator: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },
        headers: [{ text: "#Factura", value: "facturasventaPK.secuencia" }],

        search: "",
        acti_tb_data: false,

        ejecucion: false,
        aalert: {
          estado: false,
          color: null,
        },

        notif: {
          estado: false,
          nombre: "",
          Exec: "",
        },

        BarraPrimariaAbrir: true,
      }
    },
    methods: {
      currencyFormatter,
      FormatoFecha,
      HoraFormatter,
      fechaNueva,
      getParamFecha,

      // Abriendo una la barra de datos principal.
      abrirTabla() {
        this.BarraPrimariaAbrir = !this.BarraPrimariaAbrir
      },

      alerta(e, l) {
        if (l == "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e

          this.newnuevo()
        }

        if (l == "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e

          EventBus.$emit("loading", false)
        }
      },

      // Limpia el formulario.
      newnuevo() {
        Object.assign(this.proveedor, this.proveedorNuevo)
        this.unidadProductoList = []
        this.productoList = []
        this.aumento = 0
        this.modificacionesManuales = 0
        this.$refs.form.resetValidation()
        this.ejecucion = false
      },

      guardar() {
        if (this.modificacionesManuales > 0) {
          this.saveModificacionManual()
        } else {
          this.saveAumentoToSeleccionados()
        }
      },

      saveModificacionManual() {
        EventBus.$emit("loading", true)
        this.$axios
          .put(this.$hostname + this.$hName + "/unidades-productos/productos/cambiarPrecioManual", this.productoList, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Cambios de precio aplicados exitosamente!", "bien")
            this.productoList = []
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al cambiar los precios!", "error")
          })
          .finally(() => {
            EventBus.$emit("loading", false)
          })
      },

      saveAumentoToSeleccionados() {
        EventBus.$emit("loading", true)
        this.$axios
          .put(
            this.$hostname + this.$hName + "/unidades-productos/productos/cambiarPrecioSeleccionados",
            this.productoList,
            {
              headers: this.$store.getters.GetheadersAxios,
              params: {
                aumento: this.aumento,
              },
            }
          )
          .then((res) => {
            this.alerta("Cambios de precio aplicados exitosamente!", "bien")
            this.productoList = []
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al cambiar los precios!", "error")
          })
          .finally(() => {
            EventBus.$emit("loading", false)
          })
      },

      async remove() {
        if (!(await this.$refs.confirmDialog.show())) return

        let codigo = this.proveedor.codigo
        this.$axios
          .delete(this.$hostname + this.$hName + `/transportes/${codigo}`, this.proveedor, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.alerta("Eliminacion exitosa!", "bien")
            this.CargarListTb()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al eliminar!", "error")
          })
      },

      eliminar() {},

      // Se llama cuando se hace clic en una fila de la tabla.
      datostabla(e) {
        Object.assign(this.proveedor, e)
        this.unidadProductoList = []
        this.productoList = []
        this.acti_tb_data = false
      },

      // Un metodo que se llama cuando se hace clic en un boton y muestra un modal con todo los registro.
      actualiza_tb_ver() {
        this.acti_tb_data = !this.acti_tb_data
        this.Limpiarfiltro()
      },

      // Limpieza del filtro y recarga los datos de la tabla.
      Limpiarfiltro() {
        var Pg = {
          itemsLength: this.TbPaginator.itemsLength,
          itemsPerPage: this.TbPaginator.itemsPerPage,
          page: 1,
          pageCount: 1,
          pageStart: 0,
          pageStop: this.TbPaginator.itemsPerPage,
        }

        this.filtros = {
          secuencia: null,
          beneficiario: "",
          fechaInicial: null,
          fechaFinal: null,
        }

        this.TbPaginator = JSON.parse(JSON.stringify(Pg))
        this.CargarListTb()
      },

      // Un metodo que se llama cuando el usuario cambia la página de la tabla.
      CargarPaginacion(e, s) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.TbPaginator = JSON.parse(JSON.stringify(e))
        this.search = s
        this.CargarListTb()
      },

      // Obtener los datos de la lista
      CargarListTb() {
        let obj = this.TbPaginator.itemsPerPage + "/" + this.TbPaginator.pageStart + "/" + this.search
        this.$axios
          .get(this.$hostname + this.$hName + "/proveedores/findListProveedorPlus/" + obj, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.proveedorList = res.data.ListItems
            this.totalItems = res.data.TbTotalItem
          })
          .catch((error) => {
            console.error(error)
          })
      },

      findUnidadProducto(producto) {
        let codigo = this.proveedor.codigo

        this.$axios
          .get(this.$hostname + this.$hName + `/proveedores/${codigo}/productos`, {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              producto: producto,
              unidadCompra: true,
            },
          })
          .then((res) => {
            this.unidadProductoList = res.data.content
          })
          .catch((error) => {
            console.error(error)
          })
      },

      addProducto(item) {
        this.$refs.unidadProductoComplete.reset()
        if (!item || this.productoList.some((value) => value.codigobarra === item.codigobarra)) {
          return
        }
        this.productoList.unshift(item)
      },

      addProductoDialog(item) {
        if (item.estado === "cerrar") {
          this.showDialogAddProducto = false
        }
        if (item.estado === "datos") {
          this.addProducto(item.datos)
        }
      },

      formatUnidadProducto(val) {
        return `${val.productos.descripcion}`
      },

      removeProducto(producto) {
        if (!producto) return
        let index = this.productoList.indexOf(producto)
        this.productoList.splice(index, 1)
      },

      aumentoGlobal() {
        let codigo = this.proveedor.codigo

        EventBus.$emit("loading", true)
        this.$axios
          .put(this.$hostname + this.$hName + `/proveedores/${codigo}/productos/cambiarPrecioGlobal`, null, {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              aumento: this.aumento,
            },
          })
          .then((res) => {
            this.alerta("Cambios de precio aplicados exitosamente!", "bien")
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error aplicando los cambios de precio!", "error")
          })
          .finally(() => {
            EventBus.$emit("loading", false)
          })
      },

      disableAumento() {
        this.aumento = 0
        this.modificacionesManuales += 1
      },

      findAllProductos() {
        EventBus.$emit("loading", true)
        let codigo = this.proveedor.codigo
        this.$axios
          .get(this.$hostname + this.$hName + `/proveedores/${codigo}/productos/all`, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((res) => {
            this.productoList = res.data
          })
          .catch((error) => {
            console.error(error)
          })
          .finally(() => {
            EventBus.$emit("loading", false)
          })
      },
    },

    computed: {
      ActDescBtn() {
        this.windowSize = JSON.parse(JSON.stringify(this.$store.getters.GetwindowSize))
      },

      isAumentoDisabled() {
        return this.modificacionesManuales > 0
      },
    },

    watch: {
      searchUnidadProducto(val) {
        this.findUnidadProducto(val)
      },

      productoList(val) {
        this.EstadoBtn.guardar = val.length > 0
      },
    },
  }
</script>

<style>
  .form-loading-indicator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    padding: 20px;
    border-radius: 4px;
    z-index: 1;
  }
</style>
